"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeUsernameHeader = ChangeUsernameHeader;
exports.ChangeUsernameForm = ChangeUsernameForm;
exports.default = ChangeUsername;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const react_native_paper_1 = require("react-native-paper");
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("../Theme");
const Loading_1 = __importDefault(require("../components/Loading"));
const Button_1 = __importDefault(require("../components/Button"));
const UserContext_1 = require("../contexts/UserContext");
const Field_1 = __importDefault(require("../components/Field"));
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const Authentication_1 = __importDefault(require("../shared/Authentication"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        messageOuter: {
            marginTop: size != 'sm' ? 12 : 12,
            marginBottom: size != 'sm' ? -8 : 0,
        },
        message: {
            color: THEME.Red,
            fontSize: 14,
            fontWeight: '500',
            textAlign: 'center'
        }
    });
};
function ChangeUsernameHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.UserPen, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: '500', fontSize: (size != 'sm' ? 18 : 16), marginLeft: 8 }, children: t('common:appmenus.changeUser') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: "borderless", onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
;
function ChangeUsernameForm(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const styles = useStyles();
    const THEME = (0, ThemeContext_1.useTheme)();
    const [newUsername, setNewUsername] = react_1.default.useState('');
    const [confirmUsername, setConfirmUsername] = react_1.default.useState('');
    const promise = react_1.default.useRef(null);
    const [working, setWorking] = react_1.default.useState(false);
    const [message, setMessage] = react_1.default.useState(null);
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const [newUsernameError, setNewUsernameError] = react_1.default.useState(false);
    const [confirmUsernameError, setConfirmUsernameError] = react_1.default.useState(false);
    const [mismatchError, setMismatchError] = react_1.default.useState(false);
    const onSuccess = () => {
        react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "success", message: t('profile:messages.userChangeSuccess') });
        Authentication_1.default.SignOut();
    };
    const onFail = () => {
        setWorking(false);
        react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('profile:messages.userChangeFail') });
        props.onSaved();
    };
    const emailHasErrors = (value) => {
        return !/^(\w|(\w+\+\w))+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/i.test(value) ? true : false;
    };
    const save = () => {
        var emailValid = newUsername && newUsername?.length > 0 && !newUsernameError &&
            confirmUsername && confirmUsername?.length > 0 && !confirmUsernameError;
        if (newUsername.toLowerCase() != confirmUsername?.toLowerCase()) {
            setMessage(t('profile:messages.userMatch'));
            setWorking(false);
        }
        else if (emailValid) {
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                'feature': 'Change Username',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId
            });
            promise.current?.cancel();
            setMessage(null);
            setWorking(true);
            promise.current = (0, cancelable_promise_1.cancelable)(userContext
                .getToken()
                .then((t) => MyProfile_1.default.updateUsername(t, { username: newUsername.toLowerCase() }))
                .then((result) => {
                setTimeout(onSuccess, 3000);
            })
                .catch(() => {
                setTimeout(onFail, 1000);
            }));
        }
        else {
            setMessage(t('common:messages.emailHelp'));
            setWorking(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [working
                &&
                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: 'center', paddingVertical: 6 }, children: [(0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: false, loading: working }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text }, children: t('profile:messages.userChangeLoading') })] })
                ||
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:labels.currentUser'), value: userContext.user?.claims?.email }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { error: newUsernameError, label: t('profile:labels.newUser'), accessibilityLabel: t('profile:labels.newUser'), value: newUsername ?? '', autoFocus: true, mode: "outlined", onChangeText: (v) => {
                                            setNewUsername(v);
                                            setNewUsernameError(emailHasErrors(v));
                                            if (confirmUsername && confirmUsername.length > 0) {
                                                let mismatch = confirmUsername.toLowerCase() !== v.toLowerCase();
                                                setMismatchError(mismatch);
                                            }
                                        }, maxLength: 50 }), newUsernameError && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: newUsernameError ? t('common:messages.emailHelp') : '' })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { error: confirmUsernameError || mismatchError, label: t('profile:labels.newUserConf'), accessibilityLabel: t('profile:labels.newUserConf'), value: confirmUsername ?? '', mode: "outlined", onChangeText: (v) => {
                                            setConfirmUsername(v);
                                            let mismatch = v.toLowerCase() !== newUsername.toLowerCase();
                                            setMismatchError(mismatch);
                                            setConfirmUsernameError(emailHasErrors(v));
                                        }, maxLength: 50 }), (mismatchError || confirmUsernameError) && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: mismatchError ? t('profile:messages.userMatch') : confirmUsernameError ? t('common:messages.emailHelp') : '' })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", extraPadding: 4, text: t('common:buttons.cancel'), onPress: props.onCancel }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: working || newUsernameError || confirmUsernameError || mismatchError, extraPadding: 4, text: t('profile:buttons.saveUser'), onPress: save }) })] }), message &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.messageOuter, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.message, children: message }) })] }));
}
;
function ChangeUsername(props) {
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsx)(ChangeUsernameHeader, { onClose: props.onClose ?? props.navigation.goBack }) }), (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: "handled", children: (0, jsx_runtime_1.jsx)(ChangeUsernameForm, { onCancel: props.onClose ?? props.navigation.goBack, onSaved: props.onSave ?? props.navigation.goBack }) })] }));
}
;
